import React, { useEffect, useState, useContext } from "react";
import { Box, Tab, Tabs, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { obtenerDatosPost } from "../../../api/config";
import { GlobalContext } from "../../../GlobalContext";

import { NewCharts } from "./NewCharts";
import { GridDif } from "./GridDif";
import { GridDifAchieved } from "./GridDifAchieved";

const TabCharts = () => {
	const { t } = useTranslation();
	const { site_id } = useContext(GlobalContext);

	const [value, setValue] = React.useState("one");

	const [rawData, setRawData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [errorMsg, setErrorMsg] = useState("");

	useEffect(() => {
		const keySimulacion = localStorage.getItem("key");
		if (!site_id || !keySimulacion) return;

		let alive = true;

		const fetchOnce = async () => {
			setLoading(true);
			setErrorMsg("");
			try {
				const resp = await obtenerDatosPost(site_id, [keySimulacion]);
				if (!alive) return;
				setRawData(Array.isArray(resp) ? resp : []);
			} catch (err) {
				console.error("Error al obtener simulaciones:", err);
				if (!alive) return;
				setErrorMsg(t("aux.error_generic") || "Error cargando datos");
			} finally {
				if (alive) setLoading(false);
			}
		};

		fetchOnce();

		return () => {
			alive = false;
		};
	}, [site_id, t]);

	const handleChange = (_, newValue) => setValue(newValue);

	// TIP: dejo montadas las 3 tabs (no se desmontan al cambiar),
	// así mantienes selección de meses/estado interno sin re-render heavy.
	return (
		<>
			<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
				<Tabs
					centered
					role="navigation"
					textColor="primary"
					indicatorColor="primary"
					value={value}
					onChange={handleChange}
				>
					<Tab value="one" label={t("new_charts.contract")} />
					<Tab value="two" label={t("new_charts.grid_contract")} />
					<Tab value="three" label={t("new_charts.demand")} />
				</Tabs>
			</Box>

			<Box sx={{ p: 2 }}>
				{loading && (
					<Box sx={{ display: "flex", gap: 2, alignItems: "center", justifyContent: "center", py: 4 }}>
						<CircularProgress size={22} />
						<Typography variant="body2">{t("aux.loading") || "Cargando..."}</Typography>
					</Box>
				)}

				{!loading && !!errorMsg && (
					<Typography color="error" variant="body2" align="center">
						{errorMsg}
					</Typography>
				)}

				{/* keepMounted */}
				<Box hidden={value !== "one"}>
					<NewCharts data={rawData} loading={loading} />
				</Box>
				<Box hidden={value !== "two"}>
					<GridDif data={rawData} loading={loading} />
				</Box>
				<Box hidden={value !== "three"}>
					<GridDifAchieved dataOutputs={rawData} loading={loading} />
				</Box>
			</Box>
		</>
	);
};

export { TabCharts };
